function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30 28H2C0.89543 28 0 27.1046 0 26V8C0 6.89543 0.89543 6 2 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8H2V26H30V19C30 18.4477 30.4477 18 31 18C31.5523 18 32 18.4477 32 19V26C32 27.1046 31.1046 28 30 28Z",
  fill: "#32D882"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13 14H1C0.447715 14 0 13.5523 0 13C0 12.4477 0.447715 12 1 12H13C13.5523 12 14 12.4477 14 13C14 13.5523 13.5523 14 13 14Z",
  fill: "#32D882"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M9 20H5C4.44772 20 4 19.5523 4 19C4 18.4477 4.44772 18 5 18H9C9.55228 18 10 18.4477 10 19C10 19.5523 9.55228 20 9 20Z",
  fill: "#32D882"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.502 19.868C23.6536 19.9547 23.8253 20.0002 24 20C24.1747 20.0002 24.3464 19.9547 24.498 19.868C29.966 16.726 32 13.51 32 8V4C31.9997 3.59872 31.7595 3.2365 31.39 3.08L24.39 0.0799985C24.1373 -0.0256693 23.8527 -0.0256693 23.6 0.0799985L16.6 3.08C16.2344 3.23955 15.9986 3.60111 16 4V8C16 13.502 18.034 16.718 23.502 19.868ZM18 8V4.66L24 2.088L30 4.66V8C30 12.618 28.472 15.16 24 17.84C19.528 15.154 18 12.612 18 8Z",
  fill: "#32D882"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M23 13H22.958C22.6385 12.9862 22.3449 12.8204 22.168 12.554L20.168 9.554C19.9697 9.25675 19.9451 8.87631 20.1034 8.55597C20.2616 8.23563 20.5788 8.02406 20.9354 8.00097C21.2919 7.97787 21.6337 8.14675 21.832 8.444L23.074 10.306L26.218 6.374C26.5632 5.94266 27.1927 5.87282 27.624 6.218C28.0553 6.56318 28.1252 7.19266 27.78 7.624L23.78 12.624C23.5906 12.8612 23.3036 12.9996 23 13Z",
  fill: "#32D882"
});

var SvgVenueManagment5 = function SvgVenueManagment5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVenueManagment5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/venue-managment5.900df04f.svg";
export { ForwardRef as ReactComponent };